import BugReportIcon from '@mui/icons-material/BugReport';
import { Box, Fab, useTheme } from '@mui/material';
import DebugModal from 'content/modals/DebugModal';
import { useState } from 'react';
import type { FC } from 'react';

export interface DashboardWrapperProps {
  setHideFab: (value: boolean) => void;
}

const DebugFab: FC<DashboardWrapperProps> = ({ setHideFab }) => {
  const theme = useTheme();
  const [debugModalOpen, setDebugModalOpen] = useState(false);

  const toggleDebugModalOpen = (): void => setDebugModalOpen(prev => !prev);

  return (
    <Box
      position="fixed"
      bottom={theme.spacing(2)}
      right={theme.spacing(2)}
      zIndex={theme.vars.zIndex.fab}
    >
      <Fab color="primary" onClick={toggleDebugModalOpen}>
        <BugReportIcon />
      </Fab>
      {debugModalOpen ? (
        <Box
          sx={{
            backgroundColor: theme.vars.palette.grey[200],
            ...theme.applyStyles('dark', {
              backgroundColor: theme.vars.palette.grey[600],
            }),
          }}
          padding={2}
          borderRadius={1}
          boxShadow={2}
          position="fixed"
          bottom={theme.spacing(10)}
          right={theme.spacing(2)}
          zIndex={theme.vars.zIndex.fab - 1}
          width={550}
        >
          <DebugModal hideForever={() => setHideFab(true)} />
        </Box>
      ) : null}
    </Box>
  );
};

export default DebugFab;
